import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { format } from 'date-fns';
import styles from '../../assets/stylesheets/CallsheetInlineStyles';
import { onSitelocations } from '../../constants/callsheet';

class CallsheetHeader extends Component {
  getDateString = date => {
    return format(date, 'eeee MMMM d, y');
  };

  getAddress = onSiteLocation => { 
    const chabanelAddress = (
      <td valign="top">
        <strong>SSENSE</strong>
        <br />
        333 CHABANEL O.
        <br />
        FLOOR 9 / SUITE 900
        <br />
        MONTREAL, QC
        <br />
        H2N 2E7, CANADA
        <br />
        514.384.1906
        <br />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://goo.gl/maps/ZyDUNUahnPFkzrYw8"
        >
          DIRECTIONS
        </a>
      </td>
    );
    const poirierAddress = (
      <td valign="top">
        <strong>SSENSE</strong>
        <br />
        3665 Poirier Blvd
        <br />
        Door B
        <br />
        Saint-Laurent, QC
        <br />
        H4R 2J5, CANADA
        <br />
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://maps.app.goo.gl/Fj8d8Lri1MzyLfDn7"
        >
          DIRECTIONS
        </a>
      </td>
    );

    if (onSiteLocation === onSitelocations.POIRIER) {
        return poirierAddress;
    }
    return chabanelAddress;
  }

  render() {
    const { date, renderForEmail, onSiteLocation } = this.props;
    const headerComponent = (
      <table
        border="1"
        style={renderForEmail ? styles.tableEmailWidth : styles.tableFullWidth}
      >
        <thead>
          <tr>
            <th colSpan="2">
              SSENSE eCOMM PRODUCTION SCHEDULE
              <br />
              {this.getDateString(date)}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {this.getAddress(onSiteLocation)}
          </tr>
        </tbody>
      </table>
    );

    return renderForEmail ? (
      headerComponent
    ) : (
      <Paper className="bookingForm">{headerComponent}</Paper>
    );
  }
}

CallsheetHeader.defaultProps = {
  onSiteLocation: onSitelocations.CHABANEL,
};

CallsheetHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onSiteLocation: PropTypes.string,
  renderForEmail: PropTypes.bool.isRequired
};

export default CallsheetHeader;
